import { Box, Stack, Typography } from '@mui/material';
import type { ReactNode } from 'react';

type PreferenceSectionProps = {
  title: string;
  description?: string;
  /** Optional node rendered next to the title — e.g. an info tooltip icon. */
  titleAdornment?: ReactNode;
  children: ReactNode;
};

export const PreferenceSection = ({ title, description, titleAdornment, children }: PreferenceSectionProps) => (
  <Stack spacing={0.75} marginBottom={2}>
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        <Typography variant="overline" color="text.secondary">
          {title}
        </Typography>
        {titleAdornment}
      </Box>
      {description && (
        <Typography variant="body2" color="text.secondary">
          {description}
        </Typography>
      )}
    </Box>
    {children}
  </Stack>
);

PreferenceSection.displayName = 'PreferenceSection';
